import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { useAuth } from "@/context/AuthContext";
import { trackEvent, formatApiErrorDetail } from "@/lib/api";

export default function CandidateRegistration() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Please accept the consent to continue.");
    setLoading(true);
    try {
      await register({ ...form, role: "candidate" });
      trackEvent("candidate_registration");
      toast.success("Account created! Welcome to Dreamzz HR.");
      navigate("/candidate/dashboard");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <PublicLayout>
      <Seo title="Candidate Registration" description="Register as a candidate with Dreamzz HR & Consultancy to apply for jobs across Karnataka." />
      <PageHeader eyebrow="Job Seekers" title="Create Your Candidate Account" subtitle="Register to apply for jobs, save openings and get matched with opportunities." />
      <section className="max-w-md mx-auto px-4 sm:px-6 py-12">
        <form onSubmit={submit} className="glass-strong rounded-2xl p-6 sm:p-8 grid gap-4">
          <div><Label>Full Name *</Label><Input data-testid="register-name" required value={form.name} onChange={upd("name")} className="bg-white/5 border-white/10 mt-1" /></div>
          <div><Label>Email *</Label><Input data-testid="register-email" type="email" required value={form.email} onChange={upd("email")} className="bg-white/5 border-white/10 mt-1" /></div>
          <div><Label>Mobile *</Label><Input data-testid="register-phone" required value={form.phone} onChange={upd("phone")} className="bg-white/5 border-white/10 mt-1" /></div>
          <div><Label>Password *</Label><Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={upd("password")} className="bg-white/5 border-white/10 mt-1" /></div>
          <label className="flex items-start gap-3 text-sm text-slate-400">
            <Checkbox data-testid="register-consent" checked={consent} onCheckedChange={setConsent} className="mt-0.5" />
            <span>I accept the Privacy Policy, Terms and consent to communication.</span>
          </label>
          <Button data-testid="register-submit" type="submit" disabled={loading} className="btn-press bg-brand-emerald hover:bg-[#C62828] text-white font-semibold h-12">
            {loading ? "Creating..." : "Create Account"}
          </Button>
          <p className="text-center text-sm text-slate-400">Already registered? <a href="/login" className="text-brand-emerald">Login</a></p>
        </form>
      </section>
    </PublicLayout>
  );
}
